import { render } from "./App.vue?vue&type=template&id=106c281f&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=106c281f&lang=css"

import exportComponent from "C:\\Users\\Vintz\\Documents\\Github\\SiteCV\\site-cv-main-page\\site-cv-main-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__